// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  require('./assets/css/allocation.css')
  require('element-ui/lib/theme-chalk/index.css')
  require('./assets/css/index.css')
  require('./assets/css/common.css')
  require('./assets/css/login_brand.css')
  require('./assets/css/v2-common.css')
  require('./assets/css/creative-page.css')
  require('./assets/css/creative-detail.css')
  require('./assets/css/placeorder.css')
  require('./assets/css/shopping-cart.css')
  require('./assets/css/order_detail.css')
  require('./assets/css/order.css')
  require('./assets/css/order-success.css')
  require('./assets/css/case-detail.css')
  require('./assets/css/demand-case-list.css')
  require('./assets/css/demand-case-detail.css')
  require('./assets/css/service-case-list.css')
  require('./assets/css/service-case-detail.css')
  require('./assets/css/service-case-add.css')
  require('./assets/css/service-register.css')
  require('./assets/css/brand-register-page.css')
  require('./assets/css/change-password.css')
  require('./assets/css/team-company.css')
  require('./assets/css/share-list.css')
  require('./assets/css/my-project.css')
  next()
})
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  debug: true
})



// WEBPACK FOOTER //
// ./src/main.js